import { createMiddleware } from '@shared/redux';
import { LOCATION_CHANGE } from 'connected-react-router';

export const weglotMiddleware = createMiddleware({
    [LOCATION_CHANGE]: () => {
        try {
            setTimeout(() => {
                const [elem] = document.getElementsByClassName('country-selector');
                const css = { marginRight: '75px' };
                Object.assign(elem.style, css);
            }, 2000);
        } catch (e) {}
    },
});
